import React from "react";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import LockIcon from "@material-ui/icons/Lock";
import { openPricingPage } from "utils/Utils";
import styles from "./UpgradeModal.module.css";
import { SvgIcon } from "@material-ui/core";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";

export const UpgradeModal = ({
  isOpen,
  setShowUpgradeModal,
  message,
  description,
  btnText,
}) => {
  const onClose = () => {
    setShowUpgradeModal(false);
  };

  const title = <div className="tw-text-[#1C274C]">Unlock Feature</div>;

  return (
    <ExlyModal
      open={isOpen}
      title={title}
      primaryBtnText={
        <div className="tw-flex tw-items-center tw-font-[700] tw-gap-2">
          <LockOpenIcon className="!tw-text-white" />
          <div className="tw-text-white">{btnText || "Upgrade plan"}</div>
        </div>
      }
      primaryBtnClassName={styles.primaryBtn}
      onPrimaryBtnClick={openPricingPage}
      primaryBtnFullWidth
      showSecondaryBtn={false}
      onClose={onClose}
      modal_props={{
        modalPaperClassName: styles.modalPaperClassName,
      }}
    >
      <div className="tw-relative tw-text-center tw-py-4 tw-px-8">
        <div className="tw-absolute tw-inset-0 tw-opacity-20 tw-bg-[radial-gradient(53.93%_144.54%_at_50%_130.63%,_#8B08C7_0%,_rgba(139,8,199,0)_100%)] tw-z-0" />
        <div className="tw-relative tw-z-10 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2">
          <svg width={0} height={0}>
            <linearGradient
              id="custom-gradient"
              x1="0%"
              y1="100%"
              x2="0%"
              y2="0%"
            >
              <stop offset="0%" className={styles.gradientFrom} />
              <stop offset="100%" className={styles.gradientTo} />
            </linearGradient>
          </svg>
          <SvgIcon style={{ fontSize: 60 }}>
            <LockIcon style={{ fill: "url(#custom-gradient)" }} />
          </SvgIcon>

          <div className="tw-text-[#272522] tw-font-[500] tw-text-md">
            {message}
          </div>
          <div className="tw-text-[#272522] tw-text-sm tw-text-opacity-50">
            {description}
          </div>
        </div>
      </div>
    </ExlyModal>
  );
};
